import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseClientsSearch } from "@/features/accounts";
import { ClientsPage } from "@/features/accounts/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/clients/")({
  validateSearch: strictSearch(parseClientsSearch),
  component: Clients,
});

function Clients() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <ClientsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(userId) => router.buildLocation({ to: "/clients/$userId", params: { userId } }).href}
      onOpen={(userId) => void router.navigate({ to: "/clients/$userId", params: { userId } })}
    />
  );
}
